import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    notification: {
      error: 'An error occurred while sending the request. Please try again.',
      success: 'Request successfully sent!',
    },
  },
  fr: {
    notification: {
      error: `Une erreur est survenue lors de l'envoi de la demande. Veuillez réessayer.`,
      success: 'Demande envoyée avec succès !',
    },
  },
} as const);

export default locales;
